<template>
  <div class="orders" :class="theme">
    <MainBackButton :forceHome="true" />

    <section class="top" :class="theme">
      <p class="title is-5">
        <span class="header">{{ $t("orders.your-orders") }}</span>

        <span class="header-right">
          <span :style="tabStyle('ongoing')" @click="setTab('ongoing')">{{
            $t("orders.ongoing")
          }}</span>&nbsp;
          <span :style="tabStyle('past')" @click="setTab('past')">{{
            $t("orders.past")
          }}</span>
        </span>
      </p>
    </section>

    <div class="orders-wrapper">
      <section class="notification no-scrollbar" :class="theme" :key="z">
        <div v-for="(o, i) in orders" :key="i" class="order is-pointer" :class="{
          'bg-grey': tab === 'past',
          'pulse-order': i === 0 && tab === 'ongoing',
        }" @click="openDetails(o)">
          <div class="columns is-mobile is-vcentered">
            <div class="column is-narrow pic">
              <p v-if="isTest(o)" class="test">TEST</p>
              <img v-webp="profilePic(o.business)" @error="defaultImg" />
            </div>
            <div class="column has-text-left">
              <i v-if="o.workflow_type_name === 'Delivery'" class="fa fa-motorcycle fa-sm" />
              <div class="business-name">
                {{ o.business.name }}
              </div>
              <p>
                <i class="far fa-clock fa-sm" />
                <span>{{ longScheduledTime(o) }}</span>
              </p>
              <p>
                <i class="fa fa-coins fa-sm" /><span>
                  <span v-if="showCurrency(o)">{{
                    currencySymbol(o.business.country)
                  }}</span>{{ prettyPrice(o) }}
                </span>
                <span v-if="isSOL(o)" class="total-sol">{{ priceSOL(o) }} SOL</span>
                <span class="lottie">
                  <lottie-animation v-if="tab === 'past'" :animationData="lottiePast" :loop="false" />
                  <lottie-animation v-else :animationData="lottieOngoing" :loop="false" />
                </span>
              </p>
            </div>
          </div>
        </div>

        <div v-if="tab === 'ongoing'">
          <div v-for="(o, i) in recentlyFailedOrders" :key="i + 'f'" class="order is-pointer failed-bg"
            @click="openDetails(o)">
            <div class="columns is-mobile is-vcentered">
              <div class="column is-narrow pic">
                <p v-if="isTest(o)" class="test">TEST</p>
                <img v-webp="profilePic(o.business)" @error="defaultImg" />
              </div>
              <div class="column has-text-left">
                <div class="business-name">
                  {{ o.business.name }}
                </div>
                <p>
                  <i class="far fa-clock fa-sm" />
                  <span>{{ longScheduledTime(o) }}</span>
                </p>
                <p>
                  <i class="fa fa-coins fa-sm" /><span>
                    <span v-if="showCurrency(o)">{{
                      currencySymbol(o.business.country)
                    }}</span>{{ prettyPrice(o) }}
                  </span>
                  <span class="has-text-danger has-text-weight-bold">{{
                    $t("states.cancelled")
                  }}</span>
                  <span class="lottie">
                    <lottie-animation :animationData="lottieFailed" :loop="false" />
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-show="!orders.length" @click="toggleTab">
          <div class="order" style="padding: 12px">
            <p>
              <i>{{ noOrdersMessage }}</i>
            </p>
            <p v-if="tab === 'ongoing'" style="margin-top: 8px">
              <span style="font-weight: 500; opacity: 0.5">
                <span class="link">View past orders</span>
                <i class="fa fa-chevron-right" />
              </span>
            </p>
          </div>
        </div>

        <div class="bar-wrapper" @click="update">
          <i class="far fa-window-minimize has-text-grey wiggle" />
        </div>

        <div style="padding-bottom: 20px">
          <div class="order is-pointer app-install" style="border: 1px solid lightgreen" @click="goToMart">
            <div class="columns is-mobile is-vcentered">
              <div class="column is-narrow extra">
                <img src="/img/home2/grocery.svg" />
              </div>
              <div class="column has-text-left">
                <p class="has-text-grey">
                  <b>Need anything else?</b>
                </p>
                <p>TUK Mart has water, lighters, kitkats... Order now!</p>
              </div>
            </div>
          </div>

          <div v-if="!isPicante()" class="order is-pointer app-install" style="border: 1px solid pink"
            @click="goToFlowerShop">
            <div class="columns is-mobile is-vcentered">
              <div class="column is-narrow extra">
                <img src="/img/home2/flowers.svg" />
              </div>
              <div class="column has-text-left">
                <p class="has-text-grey">
                  <b>Is it a Special Day?</b>
                </p>
                <p>TUK has flowers! Order a bouquet with free delivery.</p>
              </div>
            </div>
          </div>

          <div v-if="!isApp()" class="order is-pointer app-install" style="border: 1px solid lightblue"
            @click="installApp">
            <div class="columns is-mobile is-vcentered">
              <div class="column is-narrow extra">
                <slide-y-up-transition group>
                  <i v-if="timer" class="fab fa-app-store-ios fa-5x has-text-info" :key="1" />
                  <i v-else class="fab fa-google-play fa-5x has-text-primary" :key="2" />
                </slide-y-up-transition>
              </div>
              <div class="column has-text-left">
                <p class="has-text-grey">
                  <b>Did you know TUK is an APP?</b>
                </p>
                <p>
                  Click here to install it.
                  <i class="fa fa-hand-point-left fa-2x is-pulled-right pulse" style="margin-right: 8px" />
                </p>
                <p>It works better that way.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <DeliveryDetailsModal />
    <EditTransactionModal />
  </div>
</template>


<script>
import EventBus from "../eventBus";
import { sounds } from "../functions";

import MainBackButton from "@/components/MainBackButton";
import DeliveryDetailsModal from "@/components/DeliveryDetailsModal.vue";
import EditTransactionModal from "@/components/EditTransactionModal.vue";

import LottieAnimation from "lottie-web-vue"; // import lottie-web-vue

export default {
  name: "Orders",
  components: {
    MainBackButton,
    DeliveryDetailsModal,
    EditTransactionModal, // rename this to TransportDetailsModal
    LottieAnimation,
  },
  data() {
    return {
      recentlyFailedOrders: [],
      lottiePast: require("@/assets/lottie/dropped-off.json"),
      lottieOngoing: require("@/assets/lottie/order-submitted.json"),
      lottieFailed: require("@/assets/lottie/order-cancelled.json"),
      timer: true, // for ios/android app install thing
      tab: "ongoing",
      size: window.innerWidth * 0.75,
      z: 0,
      imgFallback: {
        loading: this.$store.state.birdProfilePic,
        error: this.$store.state.errorProfilePic,
      },
      svgs: {
        ride: "/img/home2/home_ride.png",
        eat: "/img/home2/home_eat.png",
        shop: "/img/home2/home_shop.svg",
        services: "/img/home2/home_services.svg",
        logistics: "/img/home2/home_send.svg",
      },
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    orders() {
      if (this.tab === "ongoing") return this.ongoingOrders;
      else return this.pastOrders;
    },
    ongoingOrders() {
      // return this.$store.getters.getOngoingCustomerTransactions;
      var orders = this.$store.getters.getOngoingCustomerTransactions;
      orders = orders.concat(this.recentOrders);
      return orders.filter((o) => {
        if (o.is_deleted) return false;
        if (o.workflow_type_name === "Delivery") {
          if (orders.find((i) => i.id === o.data.commerce_transaction_id)) {
            return false;
          }
        }
        return true;
      });
    },
    pastOrders() {
      // return this.$store.getters.getRecentCustomerTransactions;
      var orders = this.$store.getters.getRecentCustomerTransactions;
      return orders.filter((o) => {
        if (o.is_deleted) return false;
        if (o.workflow_type_name === "Delivery") {
          if (orders.find((i) => i.id === o.data.commerce_transaction_id)) {
            return false;
          }
        }
        if (this.updatedMinutesAgo(o) < 60) return false;
        return true;
      });
    },
    recentOrders() {
      var orders = this.$store.getters.getRecentCustomerTransactions;
      return orders.filter((o) => this.updatedMinutesAgo(o) < 60);
    },
    noOrdersMessage() {
      if (this.tab === "ongoing") return this.$t("orders.no-ongoing-orders");
      return this.$t("orders.no-past-orders");
    },
  },
  mounted() {
    this.checkLogin();
    this.checkQuery();
    this.onVisibilityChange();
    this.getRecentlyFailedOrders();
    setInterval(() => (this.timer = !this.timer), 2000);
  },
  activated() {
    this.checkQuery();
    this.updateCustomerOrders();
    this.getRecentlyFailedOrders();
  },
  methods: {
    isSOL(t) {
      if (!t.data.order) return false;
      if (t.workflow_type_name !== "Commerce") return false;
      return t.data.order.payment_method === "sol";
    },
    isTest(t) {
      if (!t.data.order) return false;
      var notes = t.data.order.basket.notes;
      if (!notes) return false;
      return notes.includes("TEST ORDER");
    },
    lottieAnimation(t) {
      if (this.tab === "past")
        return require("@/assets/lottie/dropped-off.json");
      if (t.state === "completed")
        return require("@/assets/lottie/dropped-off.json");
      return require("@/assets/lottie/order-submitted.json");
    },
    getRecentlyFailedOrders() {
      // should also get recently failed ride orders...
      this.$store
        .dispatch("getRecentlyFailedCustomerCommerceOrders")
        .then((res) => (this.recentlyFailedOrders = res.data))
        .catch((err) => this.apiError(err));
    },
    goToReferral() {
      this.goto("/profile");
      setTimeout(() => {
        var msg = "See your referral code below";
        this.infoToast(msg, "top", 15000);
      }, 800);
    },
    profilePic(b) {
      if (b.profile_pic_url) return b.profile_pic_url;
      return "https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png"; // default profile photo
    },
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
    updatedMinutesAgo(t) {
      var updatedAt = new Date(t.updated_at);
      return Math.round((new Date() - updatedAt) / (1000 * 60));
    },
    installApp() {
      window.open("https://tukapp.co/install", "_blank");
    },
    checkLogin() {
      var msg = this.$t("login.login-to-see-your-orders"); // this doesn't do anything, msg not used for sms login
      if (!this.smsLoginOkay(msg)) return;
    },
    update() {
      this.updateCustomerOrders();
      sounds("navigate1");
    },
    checkQuery() {
      var query = this.$route.query;
      if (query.tab) this.tab = query.tab;
    },
    onVisibilityChange() {
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") return;
        this.updateCustomerOrders();
        this.getRecentlyFailedOrders();
      });
    },
    tabStyle(tab) {
      if (this.tab !== tab) return `color:#999; font-weight:450`;
      return null;
    },
    setTab(tab) {
      this.tab = tab;
      this.z += 1;
    },
    toggleTab() {
      if (this.tab === "ongoing") this.tab = "past";
      else this.tab = "ongoing";
    },
    openDetails(o) {
      this.requestPersistedStoragePermission();
      this.log("open_order_details", o);
      if (o.workflow_type_name === "Delivery") {
        this.goto(`commerce_order/${o.data.commerce_transaction_id}`);
        // var states = ["initiated", "confirmed", "driver_arrived", "enroute"]; // "alighted"
        // if (states.includes(o.state)) return this.goto("tuktuk");
        // EventBus.$emit("OPEN_DELIVERY_DETAILS", o);
        // this.displayModalNext(".delivery-details-modal");
      } else if (o.workflow_type_name === "Commerce") {
        this.goto(`commerce_order/${o.id}`);
        // } else if (o.workflow_type_name === "Delivery") {
        //   this.goto(`commerce_order/${o.data.commerce_transaction_id}`);
      } else if (o.state === "scheduled") {
        EventBus.$emit("EDIT_TRANSACTION", o); // VIEW_TRANSACTION
        this.$nextTick(() => this.displayModal(".edit-transaction-modal"));
      } else if (o.workflow_type_name === "") {
        this.goto("/tuktuk"); // need to change this
      } else {
        // this.goto("/tuktuk"); // else it's a transport transaction so go to /tuktuk
        this.goto("ride_booking/" + o.id);
      }
    },
    getSVG(o) {
      var type = o.workflow_type_name;
      if (type === "Commerce") return this.svgs.eat;
      return this.svgs.ride;
    },
    showCurrency(o) {
      return !isNaN(this.prettyPrice(o));
    },
    clientCash(d) {
      if (!d.fare) return 0;
      return d.fare.client || d.fare.cash; // for backward compatability
    },
    prettyPrice(o) {
      var d = o.data;
      if (o.workflow_type_name === "Commerce") {
        // add fees and discounts
        var vat = d.order.vat || 0;
        var fees = vat || 0; // backwards compatible
        var discounts =
          d.order.special_discount + d.order.fulfilment_discount || 0; // backwards compatible
        var orderValue = d.order.order_value + fees - discounts;
        if (d.delivery && d.delivery.is_free_delivery) {
          return orderValue; // commerce + free delivery
        }
        if (d.fare) {
          // return d.order.order_value + d.fare.price - d.order.delivery_subsidy;
          // return orderValue + d.fare.cash - d.order.delivery_subsidy;
          return orderValue + this.clientCash(d) - d.order.delivery_subsidy;
        }
        return orderValue; // just commerce, no delivery
      }
      // for non-commerce workflow types: delivery, transport etc
      if (d.delivery && d.delivery.is_free_delivery) {
        return this.$t("delivery.free-delivery");
      }
      if (d.delivery) {
        // return `${d.fare.cash - d.delivery.delivery_subsidy}`;
        return `${this.clientCash(d) - d.delivery.delivery_subsidy}`;
      }
      if (d.fare) {
        // if (d.fare.cash > 0) return d.fare.cash;
        if (this.clientCash(d) > 0) return this.clientCash(d);
        if (!d.fare.tukpay) return `Ask your driver for fare details`; // legacy?
        return `${d.fare.tukpay} via TukPay`;
      }
      return "Free of Charge"; // private tuk tuk?
    },
    priceSOL(o) {
      if (o.workflow_type_name !== "Commerce") return;
      var d = o.data;
      var value = 0;
      // add fees and discounts
      var vat = d.order.vat || 0;
      var fees = vat || 0; // backwards compatible
      var discounts =
        d.order.special_discount + d.order.fulfilment_discount || 0; // backwards compatible
      var orderValue = d.order.order_value + fees - discounts;
      if (d.delivery && d.delivery.is_free_delivery) {
        value = orderValue; // commerce + free delivery
      } else if (d.fare) {
        // value = orderValue + d.fare.cash - d.order.delivery_subsidy;
        value = orderValue + this.clientCash(d) - d.order.delivery_subsidy;
      } else {
        value = orderValue; // just commerce, no delivery
      }
      return this.convertEURtoSOLPretty(value);
    },
    stateClass(o) {
      var tagClass = "is-dark";
      if (o.state === "initiated") tagClass = "is-danger";
      if (o.state === "confirmed") tagClass = "is-warning";
      if (o.state === "ready") tagClass = "is-primary";
      if (o.state === "completed") tagClass = "is-success";
      if (o.state === "alighted") tagClass = "is-success";
      if (o.state === "cancelled_by_shop") tagClass = "is-danger";
      if (o.state === "timed_out") tagClass = "is-danger";
      return tagClass;
    },
  },
};
</script>

<style scoped>
.orders {
  height: 100vh;
  width: 100vw;
  /* max-width: 700px; */
  overflow: hidden;
  margin: auto;
}

.orders-wrapper {
  width: 100vw;
  max-width: 700px;
  margin: auto;
}

.total-sol {
  margin-left: 6px;
  background-color: var(--crypto-secondary);
  /* color: var(--crypto-primary); */
  padding: 0 4px;
  border-radius: 3px;
  font-weight: 500;
  color: black;
}

.top {
  /* background-color: #f0be45; */
  background-color: #ddd;
  overflow: hidden;
  /* height: 100px; */
  /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5); */
  /* margin-bottom: 6px; */
  padding-bottom: 4px;
  /* padding-left: 56px; */
  background: linear-gradient(0deg,
      #ffc800 0%,
      white 100%);

  /* background-image: url("/img/home2/home-dots-pattern.png");
  background-size: contain;
  background-position: center; */
}

.title {
  text-align: left;
  padding-top: 18px;
  margin-bottom: 12px;
}

.header {
  padding-left: 55px;
  font-weight: 450;
}

.header-right {
  float: right;
  margin-right: 12px;
  color: #333;
}

.dark .header-right {
  color: white;
}

/* .top .title {
  text-shadow: 0.5px 0.5px 0.3px black;
} */
.dark.top {
  /* background-color: #1c37bd; */
  background-color: rgb(59, 59, 59);
  background: linear-gradient(0deg,
      var(--crypto-primary) 0%,
      var(--crypto-secondary) 100%);
}

.dark .column,
.dark .header {
  color: white;
}

.dark {
  background-color: #123;
  background-color: black;
  /* background-color: #1f1b24; */
  color: white;
}

.dark .order {
  /* background-color: rgb(0, 56, 113); */
  /* background-color: #123; */
  background-color: #1f1b24;
}

.business-name {
  font-weight: 500;
  max-width: calc(100vw - 180px);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.pic.is-narrow {
  padding: 0;
  margin-right: 12px;
}

.pic img {
  border-radius: 1px;
  object-fit: cover;
  height: 90px;
  width: 90px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  margin-top: 6px;
}

.order-types img {
  position: relative;
  height: 40px;
  width: auto;
  /* z-index: 2; */
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.35));
}

.order .column {
  padding-left: 0px;
}

.order .columns {
  margin: 0 8px;
  height: 90px;
}

.order {
  margin: 5px 9px;
  /* padding: 0 0; */
  border-radius: 2px;
  background-color: white;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
}

.extra {
  margin-left: 10px;
  width: 90px;
}

.extra img {
  margin-top: 7px;
  width: 55px;
  height: auto;
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.35));
}

.order-types {
  padding: 10px;
}

/* .order-types img:active {} */
.order-types p {
  overflow: hidden;
  white-space: nowrap;
}

.notification {
  padding: 0px;
  padding-top: 6px;
  margin: 0 0;
  /* overflow-y: scroll; */
  overflow: auto;
  width: 100vw;
  max-width: 700px;
  height: calc(100vh - 62px);
  border-radius: 0;
  /* height: 100vh; */
}

.notification .columns {
  margin-left: 0;
  margin-right: 0;
}

.end-bar {
  width: 30px;
  margin-bottom: -15px;
  padding: 0 0;
}

.txn-state {
  position: absolute;
  right: 20px;
  color: grey;
}

.bar-wrapper {
  margin-top: 0px;
  margin-bottom: 24px;
}

/* loader */
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

p .fa,
p .far {
  width: 25px;
  opacity: 0.7;
}

.app-install {
  margin-top: -10px;
  margin-bottom: 20px;
  background-color: rgba(238, 238, 238, 0.041);
}

.pulse-order {
  animation: shadow-pulse 3s infinite;
}

.pulse {
  animation: shadow-pulse 1s infinite;
  border-radius: 90px;
}

@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8);
  }

  45% {
    box-shadow: 0 0 0 5px rgba(247, 211, 8);
  }

  55% {
    box-shadow: 0 0 0 5px rgba(247, 211, 8);
  }
}

.bg-grey {
  background-color: rgb(245, 245, 245);
}

.test {
  color: red;
  position: absolute;
  font-family: sans-serif;
  background-color: yellow;
  text-align: center;
  left: 0;
  /* top: 0; */
  padding: 2px 4px;
  margin: 2px;
  line-height: 1em;
  font-size: 10pt;
  border-radius: 2px;
  /* box-shadow: 1px 1px 3px grey; */
  border: 1px solid red;
  /* z-index: 9999; */
}

.lottie {
  position: absolute;
  right: 12px;
  margin-top: -14px;
  height: 45px;
  width: 45px;
}

/* .lottie {
  position: absolute;
  right: 12px;
  margin-top: 40px;
  height: 45px;
  width: 45px;
} */
.failed-bg {
  border: 1px dashed pink;
  background: repeating-linear-gradient(45deg,
      #fff,
      #fff 10px,
      rgba(253, 101, 101, 0.1) 10px,
      rgba(253, 101, 101, 0.1) 20px);
}

.dark .failed-bg {
  border: 1px dashed grey;
  background: repeating-linear-gradient(45deg,
      black,
      black 10px,
      rgba(253, 101, 101, 0.2) 10px,
      rgba(253, 101, 101, 0.2) 20px);
}

.fa-motorcycle.fa-sm {
  position: absolute;
  right: 26px;
  color: #eee;
}
</style>